import React from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="app-loading">
        <div className="text-center">
          <img src="/logo-colored.svg" alt="SusTek" className="w-12 h-12 mx-auto mb-4 animate-pulse-glow" />
          <p className="font-heading text-sm font-semibold text-primary">SusTek Control Tower</p>
          <p className="font-body text-xs text-text-secondary mt-1">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return <Dashboard />;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
